import React from "react";
import TransactionsReportView from "./TransactionsReportView";

/* "Admission Transaction" tab — applicants only, so the reference column is
   Admission ID and both UPI Reference ID and Payment Mode are dropped. */
const AdmissionTransaction = () => {
  return <TransactionsReportView type="admission" />;
};

export default AdmissionTransaction;
